import { voucherConstants } from "../constants/voucherConstants";
import { voucherService } from "../../services/API/voucherService";
export const voucherActions = {
  add_voucher,
  getdealForVoucher,
  getVoucherList,
  redeem_voucher,
  checkEmail,
  renderAutoEmail,
  checkQuantity,
  updateStatus,
  getMerchantDeals,
  getMerchantVoucherList,
  getArchiveMerchantVoucherList,
  getVoucherDetail,
  getVoucherSpecificDetails,
  edit_voucher,
  edit_archivevoucher,
  getMerchantAllVoucherList,
  upload_TrackingNumbers,
  getUploadTrackingHistory,
  export_PurchaserList,
  export_PurchaserArchiveList,
  voucherTransfer,
  refundVoucher,
  getOrderHistory,
  resendVoucher,
  resendarchiveVoucher,
  deactivateRecurring,
  activateRecurring,
  updateRecurring,
  getArchivevoucherList,
  getVoucherarchiveDetail,
};

function getOrderHistory(formdata) {
  return (dispatch) => {
    voucherService.getOrderHistory(formdata).then(
      (orderdata) => {
        dispatch(success(orderdata));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(orderdata) {
    return { type: voucherConstants.GET_ORDER_HISTORY_REQUEST, orderdata };
  }
  function success(orderdata) {
    return { type: voucherConstants.GET_ORDER_HISTORY_SUCCESS, orderdata };
  }
  function failure(error) {
    return { type: voucherConstants.GET_ORDER_HISTORY_FAILURE, error };
  }
}

export const add_voucher = (postData) => {
  return (dispatch) => {
    voucherService.add_voucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.ADD_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.ADD_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.ADD_VOUCHER_FAILURE, error };
  }
};

export const getdealForVoucher = () => {
  return (dispatch) => {
    voucherService.getdealForVoucher().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_DEAL_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_DEAL_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_DEAL_VOUCHER_FAILURE, error };
  }
};

export const getVoucherList = (formData) => {
  return (dispatch) => {
    voucherService.getVoucherList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_VOUCHER_FAILURE, error };
  }
};

export const getArchivevoucherList = (formData) => {
  return (dispatch) => {
    voucherService.archivevoucherList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_AVOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_AVOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_AVOUCHER_FAILURE, error };
  }
};

export const getMerchantVoucherList = (dealID) => {
  return (dispatch) => {
    voucherService.getMerchantVoucherList(dealID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_MERCHANT_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_MERCHANT_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_MERCHANT_VOUCHER_FAILURE, error };
  }
};

export const getArchiveMerchantVoucherList = (dealID) => {
  return (dispatch) => {
    voucherService.getArchiveMerchantVoucherList(dealID).then(
      (data) => {
      
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_MERCHANT_ARCHIVEVOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_ARCHIVEMERCHANT_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_MERCHANT_ARCHIVEVOUCHER_FAILURE, error };
  }
};

export const getMerchantAllVoucherList = (dealID) => {
  return (dispatch) => {
    voucherService.getMerchantVoucherList(dealID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_MERCHANT_ALLVOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_MERCHANT_ALLVOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_MERCHANT_ALLVOUCHER_FAILURE, error };
  }
};

export const redeem_voucher = (postData) => {
  return (dispatch) => {
    voucherService.redeem_voucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.REDEEM_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.REDEEM_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.REDEEM_VOUCHER_FAILURE, error };
  }
};

export const checkEmail = (emailID) => {
  return (dispatch) => {
    voucherService.checkEmail(emailID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.CHECK_EMAIL_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.CHECK_EMAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.CHECK_EMAIL_FAILURE, error };
  }
};

export const checkQuantity = (qty) => {
  return (dispatch) => {
    voucherService.checkQuantity(qty).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.CHECK_QTY_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.CHECK_QTY_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.CHECK_QTY_FAILURE, error };
  }
};

export const renderAutoEmail = (emailtext) => {
  return (dispatch) => {
    voucherService.renderAutoEmail(emailtext).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.AUTO_EMAIL_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.AUTO_EMAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.AUTO_EMAIL_FAILURE, error };
  }
};

export const updateStatus = (voucherID, status) => {
  return (dispatch) => {
    voucherService.updateStatus(voucherID, status).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.UPDATE_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.UPDATE_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.UPDATE_STATUS_FAILURE, error };
  }
};

export const getMerchantDeals = (userID, postData) => {
  return (dispatch) => {
    voucherService.getMerchantDeals(userID, postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_MERCHANT_DEAL_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_MERCHANT_DEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_MERCHANT_DEAL_FAILURE, error };
  }
};

export const getVoucherDetail = (voucherID) => {
  return (dispatch) => {
    voucherService.getVoucherDetail(voucherID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_VOUCHER_DETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_VOUCHER_DETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_VOUCHER_DETAIL_FAILURE, error };
  }
};

export const getVoucherarchiveDetail = (voucherID) => {
  return (dispatch) => {
    voucherService.getVoucherarchiveDetail(voucherID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_AVOUCHER_DETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_AVOUCHER_DETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.GET_AVOUCHER_DETAIL_FAILURE, error };
  }
};

export const getVoucherSpecificDetails = (voucherID) => {
  return (dispatch) => {
    voucherService.getVoucherSpecificDetails(voucherID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_VOUCHER_SPECIFIC_DETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_VOUCHER_SPECIFIC_DETAIL_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: voucherConstants.GET_VOUCHER_SPECIFIC_DETAIL_FAILURE,
      error,
    };
  }
};

export const edit_voucher = (postData) => {
  return (dispatch) => {
    voucherService.edit_voucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.EDIT_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.EDIT_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.EDIT_VOUCHER_FAILURE, error };
  }
};

export const edit_archivevoucher = (postData) => {
  return (dispatch) => {
    voucherService.edit_archivevoucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.EDIT_AVOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.EDIT_AVOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.EDIT_AVOUCHER_FAILURE, error };
  }
};

export const upload_TrackingNumbers = (postData) => {
  return (dispatch) => {
    voucherService.upload_TrackingNumbers(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.UPLOAD_TRACKING_NO_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.UPLOAD_TRACKING_NO_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.UPLOAD_TRACKING_NO_FAILURE, error };
  }
};

export const getUploadTrackingHistory = (dealID) => {
  return (dispatch) => {
    voucherService.getUploadTrackingHistory(dealID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.GET_UPLOAD_TRACKING_HISTORY_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.GET_UPLOAD_TRACKING_HISTORY_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: voucherConstants.GET_UPLOAD_TRACKING_HISTORY_FAILURE,
      error,
    };
  }
};

export const export_PurchaserList = (postData) => {
  return (dispatch) => {
    voucherService.export_PurchaserList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.EXPORT_PURCHASER_LIST_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.EXPORT_PURCHASER_LIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.EXPORT_PURCHASER_LIST_FAILURE, error };
  }
};

export const export_PurchaserArchiveList = (postData) => {
  return (dispatch) => {
    voucherService.export_PurchaserArchiveList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.EXPORT_ARCHIVEPURCHASER_LIST_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.EXPORT_ARCHIVEPURCHASER_LIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.EXPORT_ARCHIVEPURCHASER_LIST_FAILURE, error };
  }
};


export const voucherTransfer = (postData) => {
  return (dispatch) => {
    voucherService.voucherTransfer(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.VOUCHER_TRANSFER_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.VOUCHER_TRANSFER_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.VOUCHER_TRANSFER_FAILURE, error };
  }
};

export const refundVoucher = (postData) => {
  return (dispatch) => {
    voucherService.refundVoucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.POST_REFUND_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.POST_REFUND_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.POST_REFUND_FAILURE, error };
  }
};

export const resendVoucher = (postData) => {
  return (dispatch) => {
    voucherService.resendVoucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.POST_RESEND_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.POST_RESEND_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.POST_RESEND_FAILURE, error };
  }
};

export const resendarchiveVoucher = (postData) => {
  return (dispatch) => {
    voucherService.resendarchiveVoucher(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.POST_ARESEND_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.POST_ARESEND_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.POST_ARESEND_FAILURE, error };
  }
};


export const deactivateRecurring = (postData) => {
  return (dispatch) => {
    voucherService.deactivateRecurring(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.POST_DEACTIVERECURRUING_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.POST_DEACTIVERECURRUING_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.POST_DEACTIVERECURRUING_FAILURE, error };
  }
};

export const activateRecurring = (postData) => {
  return (dispatch) => {
    voucherService.activateRecurring(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.POST_ACTIVERECURRUING_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.POST_ACTIVERECURRUING_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.POST_ACTIVERECURRUING_FAILURE, error };
  }
};

export const updateRecurring = (postData) => {
  return (dispatch) => {
    voucherService.updateRecurring(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: voucherConstants.POST_UPDATERECURRING_REQUEST, data };
  }
  function success(data) {
    return { type: voucherConstants.POST_UPDATERECURRING_SUCCESS, data };
  }
  function failure(error) {
    return { type: voucherConstants.POST_UPDATERECURRING_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/voucherActions.js